import { Injectable } from '@angular/core';
import {OnlineConnectionService} from '../connection/online-connection.service';
import {NetworkApiService} from '../../../../services/api/network/online/network/network-api.service';
import {OnlinePeerConnectionService} from '../peer-connection/online-peer-connection.service';
import * as _ from 'lodash';
import {NetworkCommonService} from '../../common/network-common.service';
import {InformationDialogComponent} from '../../../../dialogs/information-dialog/information-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {MapService} from '../../map/map/map.service';
import {SnackBarService} from '../../../../services/common/snack-bar/snack-bar.service';
import {ClusterDialogComponent} from '../../../map/cluster-dialog/cluster-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class OnlineNetworkService {

  constructor(private connectionService: OnlineConnectionService,
              private pconService: OnlinePeerConnectionService,
              private networkApiService: NetworkApiService,
              private snackBarService: SnackBarService,
              private mapService: MapService,
              private dialog: MatDialog) {}

  public dragEdge(draggedEdgeObject, illegalDragCallback): void {
    const dragStructure = NetworkCommonService.getDragStructure(draggedEdgeObject);

    if (this.isDragLegal(dragStructure)) {
      if (_.isEqual(dragStructure, 'n2n') || _.isEqual(dragStructure, 'n2t')) {
        this.connectionService.addConnection(draggedEdgeObject.from.dataItem.id, draggedEdgeObject.to.dataItem.id);
      } else if (_.isEqual(dragStructure, 't2n')) {
        this.connectionService.addConnection(draggedEdgeObject.to.dataItem.id, draggedEdgeObject.from.dataItem.id);
      } else if (_.isEqual(dragStructure, 't2v')) {
        this.pconService.addVirtualPCon(draggedEdgeObject.from.dataItem, draggedEdgeObject.to.dataItem);
      } else {
        this.pconService.addVirtualPCon(draggedEdgeObject.to.dataItem, draggedEdgeObject.from.dataItem);
      }
    } else {
      illegalDragCallback();
    }
  }

  public syncTopology(): void {
    this.networkApiService.syncTopology().then(() => {
      const dialogRef = this.dialog.open(InformationDialogComponent, {
        width: '460px',
        data: {
          message: 'Sync Topology started'
        }
      });

      dialogRef.componentInstance.onApply.subscribe(() => {
        dialogRef.close();
      });

      this.refreshDiagram();
    });
  }

  public editCluster(cluster, onOk): void {
    const dialogRef = this.dialog.open(ClusterDialogComponent, {
      data: {
        isEditMode: true,
        selectedItem: cluster
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      dialogRef.close();
      this.snackBarService.display(`"${result.name}" successfully edited`);
      onOk(result);
      this.refreshDiagram();
    });

  }

  private isDragLegal(structure): boolean {
    const legalDrags = ['n2n', 't2n', 'n2t', 't2v', 'v2t'];
    return legalDrags.indexOf(structure) > -1;
  }

  private refreshDiagram(): void {
    // this.sharedEventService.broadcast('PeriodicRefresh');
    this.mapService.refresh();
  }
}
